import { Directive, forwardRef, Input } from '@angular/core';
import {
    AbstractControl,
    NG_VALIDATORS,
    ValidationErrors,
    Validator,
    ValidatorFn,
} from '@angular/forms';

/**
 * Validator function for checking if the value is empty or contains only whitespace.
 *
 * @returns validator function
 */
export function whitespaceOrEmptyValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const isEmptyOrWhitespace = (control.value || '').trim().length === 0;
        return isEmptyOrWhitespace ? { required: true } : null;
    };
}

/**
 * Validator directive for checking if the value is empty or contains only whitespace.
 *
 * @usageNotes Meant for template driven forms.
 *
 * @example
 * <input type="text" whitespaceOrEmpty />
 * <input type="text" whitespaceOrEmpty [whitespaceOrEmptyApplyCondition]="lang === DEFAULT_LANG" />
 */
@Directive({
    selector: '[whitespaceOrEmpty]',

    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => WhitespaceOrEmptyValidatorDirective),
            multi: true,
        },
    ],
})
export class WhitespaceOrEmptyValidatorDirective implements Validator {
    /**
     * Whether to apply the whitespace or empty validator.
     * @default true - apply the validator.
     */
    @Input('whitespaceOrEmptyApplyCondition') applyCondition: boolean = true;

    validate(control: AbstractControl): ValidationErrors | null {
        return this.applyCondition
            ? whitespaceOrEmptyValidator()(control)
            : null;
    }
}
